import { jsx as _jsx } from "react/jsx-runtime";
import { useContext, useMemo } from 'react';
import { ScopeContext } from './context.js';
import { getGlobalScope, SignalScope } from '../internals/contexts.js';
import { hashValue } from '../internals/utils/hash.js';
export function ContextProvider({ children, contexts = [], inherit = true, }) {
    const parentScope = useContext(ScopeContext) ?? getGlobalScope();
    const scope = useMemo(() => new SignalScope(contexts, inherit ? parentScope : undefined), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [parentScope, inherit, hashValue(contexts)]);
    return _jsx(ScopeContext.Provider, { value: scope, children: children });
}
